export default "__VITE_ASSET__DMxosCt9__"